import { h, Component } from "preact";
import { route, Router } from "preact-router";
import Home from "../routes/home";
import Profile from "../routes/profile";
import Login from "../routes/login";
import ForgotPassword from "../routes/forgot-password";
import { getCurrentUser } from "../api/users";
import Navbar from "../components/navbar";
import Sidebar from "../components/sidebar";
import Customer from "../routes/customer";
import Customers from "../routes/customers";
import Forms from "../routes/forms";
import Files from "../routes/files";
import File from "../routes/file";
import Form from "../routes/form";
import Quotes from "../routes/quotes";
import Quote from "../routes/quote";
import Policies from "../routes/policies";
import FormView from "../routes/form-view";
import FormQuestions from "../routes/form-questions";
import FormQuestion from "../routes/form-question";
import FormQuestionElements from "../routes/form-question-elements";
import FormQuestionElement from "../routes/form-question-element";
import Vehicles from "../routes/vehicles";
import Webhooks from "../routes/webhooks";
import Contents from "../routes/contents";
import Stats from "../routes/stats";
import Content from "../routes/content";
import Products from "../routes/products";
import Updates from "../routes/updates";
import Users from "../routes/users";
import PolicyPayment from "../routes/policy-payment";
import Policy from "../routes/policy";
import SupportingDocuments from "../routes/supporting-documents";
import SupportingDocument from "../routes/supporting-document";
import UnpaidBills from "../routes/unpaid-bills";
import UnpaidBill from "../routes/unpaid-bill";
import Variables from "../routes/variables";
import Subscription from "../routes/subscription";
import User from "../routes/user/index";
import Isicom from "../lib/isicom";
import IsicomTest from "../routes/isicom";
import moment from "moment";
import UserView from "../routes/user/view";
import CallToast from "../components/call-toast";
import IsicomGetStarted from "./isicom-getstarted";
import config from "../lib/config";
import SupportingDocumentCodes from "../routes/supporting-document-codes";
import SupportingDocumentCode from "../routes/supporting-document-code";
import NotificationProvider from "./notification-provider";
import NotificationZone from "./notification-zone";
import SupportingDocumentsConfig from "../routes/supporting-documents-config";
import SupportingDocumentCategory from "../routes/supporting-document-category";
import SupportingDocumentConfig from "../routes/supporting-document-config";
import Claims from "../routes/claims";
import Claim from "../routes/claim";
import Reclamations from "../routes/complains";
import SaveComplain from "../routes/save-complain";
import Termination from "../routes/termination";
import Terminations from "../routes/terminations";
import SupportingDocumentRE7 from "../routes/supporting-document-re7";
import SaveQuote from "../routes/save-quote";
import ProductFields from "../routes/product-fields";
import Fields from "../routes/fields";
import FieldSave from "../routes/field-save";
import FieldGroups from "../routes/field-groups";
import SaveFieldGroup from "../routes/save-field-group";
import CustomerSave from "../routes/customer-save";
import Formulas from "../routes/formulas";
import SaveFormula from "../routes/save-formula";
import Scripts from "../routes/scripts";
import SaveScript from "../routes/save-script";
import DocumentTemplates from "../routes/document-templates";
import SaveDocumentTemplate from "../routes/save-document-template";
import SaveDocument from "../routes/save-document";
import Covers from "../routes/covers";
import SaveCover from "../routes/save-cover";
import FormulaCovers from "../routes/formula-covers";
import SaveFormulaCover from "../routes/save-formula-cover";
import SavePolicy from "../routes/save-policy";
import Events from "../routes/events";
import SaveEvent from "../routes/save-event";
import ConfirmationModalProvider from "../contexts/confirmation-modal";
import SignContract from "../routes/sign-contract";
import Invoicing from "../routes/invoicing";
import Invoicings from "../routes/invoicings";
import UnpaidFiles from "../routes/unpaid-files";
import { registerLocale } from "react-datepicker";
import fr from "date-fns/locale/fr"; // the locale you want
import SignCallback from "../routes/sign-callback";
import SaveClaim from "../routes/claims/save";
import 'animate.css';
import ProductSave from "../routes/products/save";
import SaveNote from "../routes/save-note";
import MigrationComponent from "../routes/migration";
import EmailTemplates from "../routes/email-templates";
import SaveEmailTemplate from "../routes/email-templates/save";
import UnpaidFile from "../routes/unpaid-file";
import TerminationReasons from "../routes/termination-reasons";
import ScriptCategories from "../routes/script-categories";
import Jobs from "../routes/jobs";
import ScheduledTasks from "../routes/scheduled-tasks";
import algoliasearch from 'algoliasearch/lite';
import { InstantSearch } from 'react-instantsearch';
import 'instantsearch.css/themes/satellite.css';
import "@algolia/autocomplete-theme-classic";
import Envbar from "./envbar";
import ScheduledTask from "../routes/scheduled-task";
import Disks from "../routes/disks";
import Settings from "../routes/settings";
import { PrimeReactProvider } from "primereact/api";
import applyBrandFavicon from "../lib/dynamicFavicon";
import useUserStore from "../store/userStore";
import { WithPermission } from "./permission/withPermission";
import { PERMISSIONS } from "../lib/security/permissions";
import UnauthorisedAccess from "./permission/unauthorisedAccess";
import { ROLES } from "../lib/security/roles";

const searchClient = algoliasearch('SJ3SUE6PNW', 'd547518425638b7aae11544d162e0e25');

export default class App extends Component {
    state = {
        darkMode: false
    };

    constructor(props) {
        super(props);
        this.state = {
            darkMode: localStorage.getItem("darkMode") === "true",
            status: useUserStore.getState().status,
        }


        // add data-bs-theme attribute to html tag
        //document.querySelector("html").setAttribute("data-bs-theme", this.state.darkMode ? "dark" : "light");

        // filter invert
        //document.querySelector("html").style.filter = this.state.darkMode ? "invert(0.91) hue-rotate(180deg) saturate(1.5)" : "none";
        document.querySelector("html").classList.add(this.state.darkMode ? "theme-dark" : "theme-light");

        if (this.state.darkMode) {
            this.addDarkModeStyle();
        }

    }

    addDarkModeStyle = () => {
        // add style tag to head
        let style = document.createElement("style");
        style.id = "dark-mode-style";
        style.innerHTML = `
          html {
              filter: invert(0.92) hue-rotate(180deg);
          }
          iframe {
              filter: invert(0.92) hue-rotate(180deg);
          }
          .ignore-theme {
              filter: none;
          }
    `;
        document.head.appendChild(style);
    };

    componentDidMount() {
        // Set favicon dynamically according to brand configuration (if any)
        try {
            applyBrandFavicon();
        } catch (e) {
            // swallow errors to avoid breaking the app startup
            console.warn('applyBrandFavicon error', e);
        }

        const unsubscribe = useUserStore.subscribe(
            (state) => state.user.status,
            (status, previousStatus) => {
                switch (status) {
                    case "login":
                        this.loadUser().then(r => {
                            if (config.isicom.enable === 'true') {
                                this.initIsicom();
                            }
                        });
                        return

                    case null:
                        route('/login');
                        return
                }
            },
        )

        registerLocale("fr", fr);
    }

    initIsicom = () => {
        if (config.isicom.enable === 'false') {
            return false;
        }

        if (!useUserStore.getState().user) {
            return false;
        }

        const agentId = useUserStore.getState().user?.metadata?.isicom_agent_id;

        if (agentId) {
            const isicom = new Isicom({
                agentId: agentId,
                onCallAlert: (args) => {
                    this.onCallAlert(args);
                },
                onCallEnded: (args) => {
                    this.onCallEnded(args);
                },
                onStatusChange: (args) => {
                    this.onStatusChange(args);
                },
                onAutomateCall: (args) => {
                    this.onAutomateCall(args);
                },
                onCallEstablished: (args) => {
                    this.onCallEstablished(args);
                },
                onIdentificationAsked: (args) => {
                    this.onIdentificationAsked(args);
                },
            });

            isicom.getSocket().on("connect", () => {
                this.setState({ isicom: isicom });
            });

            this.setState({ isicom: isicom });
        } else {
            const isicomDoNotDisplay = window.localStorage.getItem(
                "showisicomgetstarted"
            );
            if (!isicomDoNotDisplay) {
                this.setState({ showIsicomGetStarted: true });
            }
        }
    };

    loadUser = async () => {

        try {
            await useUserStore.getState().loadUserInfo()

        } catch (ex) {
            console.error(ex);
        }
    };

    handleRoute = (e) => {
        this.setState(
            {
                currentUrl: e.url,
                currentPath: e.current !== null ? e.current.props.path : null,
            },
            () => {
                this.checkAuth()
            }
        );
    };

    checkAuth = () => {
        switch (this.state.currentPath) {
            case "login":
            case "/login":
                if (useUserStore.getState().user?.id ?? false) {
                    route(`/`);
                }
                break;
            case "/forgot-password":
                break;
            default:
                if (!(useUserStore.getState().user?.id ?? false)) {
                    route(`/login`);
                }
                break;
        }
    };

    showNav = () => {
        switch (this.state.currentPath) {
            case "/login":
                return false;
            case "/forgot-password":
                return false;
            case "/forms/:id/view":
                return false;
            default:
                return true;
        }
    };

    showTopbar = () => {
        switch (this.state.currentPath) {
            case "/forgot-password":
                return false;
            case "/forms/:id/view":
                return false;
            default:
                return true;
        }
    };

    onCallAlert = (data) => {
        let type = "";

        if (data.from?.length <= 0) {
            type = "automate";
        } else {
            type = "incoming";
        }

        data.type = type;
        data.createdAt = moment();

        if (type === "automate") {
            return;
        }

        this.setState({
            call: data,
        });
    };

    onAutomateCall = (data) => {
        let call = {};

        call.type = "automate";
        call.agentId = data.agentId;
        call.metadata = data;
        call.createdAt = moment();

        this.setState({
            call,
        });
    };

    onCallEnded = (data) => {
        data.endedAt = moment();
        this.setState({
            call: null,
        });
    };

    onCallEstablished = (data) => {
        let d = {
            establishedAt: moment(),
            status: "established",
        };

        this.setState({
            call: { ...this.state.call, ...d },
        });
    };

    onStatusChange = (data) => {
        let isicom = this.state.isicom;

        isicom.setAgentStatus(data.status);

        this.setState({
            isicom: isicom,
        });
    };

    onIdentificationAsked = (data) => {
        data.createdAt = moment();
        data.type = "outgoing";

        this.setState({ call: data });
    };

    answerCall = () => {
        this.state.isicom.answerCall(this.state.call.id);
    };

    hangUpCall = () => {
        this.state.isicom.hangUpCall(this.state.call.id);
    };



    render() {
        return (
            <>
                <PrimeReactProvider value={{ unstyled: true }}>
                    <InstantSearch searchClient={searchClient} indexName="instant_search">

                        <ConfirmationModalProvider>
                            <NotificationProvider>
                                <div id="app">
                                    <Envbar />

                                    {this.showTopbar() ? (
                                        <Navbar
                                            darkMode={this.state.darkMode}
                                            user={useUserStore.getState().user}
                                            currentPath={this.state.currentPath}
                                            isicom={this.state.isicom}
                                        />
                                    ) : null}

                                    <main id="main" class="d-flex position-relative">
                                        {this.showNav() ? (
                                            <Sidebar
                                                user={useUserStore.getState().user}
                                                currentPath={this.state.currentPath}
                                            />
                                        ) : null}

                                        <div id="content" class="flex-grow-1 position-relative">
                                            {this.state.call ? (
                                                <>
                                                    <CallToast
                                                        isicom={this.state.isicom}
                                                        onAnswer={this.answerCall}
                                                        onHangUp={this.hangUpCall}
                                                        call={this.state.call}
                                                        onClose={this.onCallEnded}
                                                    />
                                                </>
                                            ) : null}

                                            <NotificationZone />

                                            {this.state.showIsicomGetStarted && config.isicom.enable === "true" ? (
                                                <IsicomGetStarted
                                                    onHide={() =>
                                                        this.setState({ showIsicomGetStarted: false })
                                                    }
                                                    show={this.state.showIsicomGetStarted}
                                                    isicom={this.state.isicom}
                                                />
                                            ) : null}
                                            <div className={`h-100`}>
                                                <Router onChange={this.handleRoute}>

                                                    <Home path="/" />

                                                    <WithPermission path="/customers"
                                                        requiredPermissions={[PERMISSIONS.CUSTOMER_LIST]}
                                                        renderOtherWise={UnauthorisedAccess()}
                                                    >
                                                        <Customers user={useUserStore.getState().user} />
                                                    </WithPermission>

                                                    <WithPermission
                                                        path="/customers/:id"
                                                        requiredPermissions={[PERMISSIONS.CUSTOMER_LIST]}
                                                        renderOtherWise={UnauthorisedAccess()}
                                                    >
                                                        <Customer
                                                            path="/customers/:id"
                                                            user={useUserStore.getState().user}
                                                            isicom={this.state.isicom}
                                                        />
                                                    </WithPermission>

                                                    <Forms path="/forms" user={useUserStore.getState().user} />
                                                    <WithPermission
                                                        path="/quotes"
                                                        requiredPermissions={[PERMISSIONS.QUOTE_LIST]}
                                                        renderOtherWise={UnauthorisedAccess()}
                                                    >
                                                        <Quotes user={useUserStore.getState().user} />
                                                    </WithPermission>
                                                    <WithPermission
                                                        path="/quotes/:id"
                                                        requiredPermissions={[PERMISSIONS.QUOTE_LIST]}
                                                        renderOtherWise={UnauthorisedAccess()}
                                                    >
                                                        <Quote
                                                            user={useUserStore.getState().user}
                                                            isicom={this.state.isicom}
                                                        />
                                                    </WithPermission>
                                                    <WithPermission
                                                        path="/policies/:id"
                                                        requiredPermissions={[PERMISSIONS.POLICY_LIST]}
                                                        renderOtherWise={UnauthorisedAccess()}
                                                    >
                                                        <Policy

                                                            user={useUserStore.getState().user}
                                                            isicom={this.state.isicom}
                                                        />
                                                    </WithPermission>
                                                    <WithPermission
                                                        path="/policies"
                                                        requiredPermissions={[PERMISSIONS.POLICY_LIST]}
                                                        renderOtherWise={UnauthorisedAccess()}
                                                    >
                                                        <Policies user={useUserStore.getState().user} />
                                                    </WithPermission>

                                                    <Files path="/files" user={useUserStore.getState().user} />
                                                    <File path="/files/save-file/:id?" user={useUserStore.getState().user} />
                                                    <Vehicles path="/vehicles" user={useUserStore.getState().user} />
                                                    <Webhooks path="/webhooks" user={useUserStore.getState().user} />
                                                    <Contents path="/contents" user={useUserStore.getState().user} />
                                                    <Content
                                                        path="/contents/save/:id?"
                                                        user={useUserStore.getState().user}
                                                    />
                                                    <Stats path="/stats" user={useUserStore.getState().user} />
                                                    <Products path="/products" user={useUserStore.getState().user} />
                                                    <Users path="/users" user={useUserStore.getState().user} />

                                                    <WithPermission
                                                        path="/claims"
                                                        requiredPermissions={[PERMISSIONS.CLAIM_LIST]}
                                                        renderOtherWise={UnauthorisedAccess()}
                                                    >
                                                        <Claims user={useUserStore.getState().user} />
                                                    </WithPermission>
                                                    <WithPermission
                                                        path="/claims/:id"
                                                        requiredPermissions={[PERMISSIONS.CLAIM_LIST]}
                                                        renderOtherWise={UnauthorisedAccess()}
                                                    >
                                                        <Claim
                                                            user={useUserStore.getState().user}
                                                            isicom={this.state.isicom}
                                                        />
                                                    </WithPermission>

                                                    <Reclamations path="/complains" user={useUserStore.getState().user} />

                                                    <SaveComplain path="/save-complain/:id?" user={useUserStore.getState().user} />

                                                    <Jobs path="/jobs" user={useUserStore.getState().user} />


                                                    <WithPermission
                                                        path="/terminations"
                                                        requiredPermissions={[PERMISSIONS.REQUEST_LIST]}
                                                        renderOtherWise={UnauthorisedAccess()}
                                                    >
                                                        <Terminations user={useUserStore.getState().user} />
                                                    </WithPermission>

                                                    <WithPermission
                                                        path="/terminations/:id"
                                                        requiredPermissions={[PERMISSIONS.REQUEST_LIST]}
                                                        renderOtherWise={UnauthorisedAccess()}
                                                    >
                                                        <Termination
                                                            user={useUserStore.getState().user}
                                                            isicom={this.state.isicom}
                                                        />
                                                    </WithPermission>

                                                    <Updates path="/updates" user={useUserStore.getState().user} />
                                                    <PolicyPayment
                                                        path="/policies/:id/payment"
                                                        user={useUserStore.getState().user}
                                                    />
                                                    <WithPermission
                                                        path="/supporting-documents"
                                                        requiredPermissions={[PERMISSIONS.CUSTOMER_LIST]}
                                                        renderOtherWise={UnauthorisedAccess()}
                                                    >
                                                        <SupportingDocuments
                                                            user={useUserStore.getState().user}
                                                        />
                                                    </WithPermission>

                                                    <WithPermission
                                                        path="/supporting-documents/:id"
                                                        requiredPermissions={[PERMISSIONS.CUSTOMER_LIST]}
                                                        renderOtherWise={UnauthorisedAccess()}
                                                    >
                                                        <SupportingDocument
                                                            user={useUserStore.getState().user}
                                                        />
                                                    </WithPermission>

                                                    <WithPermission
                                                        path="/supporting-documents-config"
                                                        requiredPermissions={[PERMISSIONS.CUSTOMER_LIST]}
                                                        renderOtherWise={UnauthorisedAccess()}
                                                    >
                                                        <SupportingDocumentsConfig
                                                            user={useUserStore.getState().user}
                                                        />
                                                    </WithPermission>

                                                    <WithPermission
                                                        path="/supporting-document-category/:id"
                                                        requiredPermissions={[PERMISSIONS.CUSTOMER_LIST]}
                                                        renderOtherWise={UnauthorisedAccess()}
                                                    >
                                                        <SupportingDocumentCategory
                                                            user={useUserStore.getState().user}
                                                        />
                                                    </WithPermission>

                                                    <WithPermission
                                                        path="/supporting-document-config/:id"
                                                        requiredPermissions={[PERMISSIONS.CUSTOMER_LIST]}
                                                        renderOtherWise={UnauthorisedAccess()}
                                                    >
                                                        <SupportingDocumentConfig
                                                            user={useUserStore.getState().user}
                                                        />
                                                    </WithPermission>

                                                    <UnpaidBills path="/unpaid-bills" user={useUserStore.getState().user} />
                                                    <UnpaidBill
                                                        path="/unpaid-bills/:id"
                                                        user={useUserStore.getState().user}
                                                    />
                                                    <Variables path="/variables" user={useUserStore.getState().user} />
                                                    <Subscription
                                                        path="/subscription/:id"
                                                        user={useUserStore.getState().user}
                                                    />
                                                    <User path="/users/save/:id?" user={useUserStore.getState().user} />
                                                    <UserView path="/users/show/:id" user={useUserStore.getState().user} />

                                                    <Form path="/forms/:id" user={useUserStore.getState().user} />
                                                    <FormView path="/forms/:id/view" user={useUserStore.getState().user} />
                                                    <FormQuestions
                                                        path="/forms/:id/questions"
                                                        user={useUserStore.getState().user}
                                                    />
                                                    <FormQuestion
                                                        path="/forms/:form_id/save-question/:id?"
                                                        user={useUserStore.getState().user}
                                                    />
                                                    <FormQuestionElements
                                                        path="/forms/:form_id/questions/:id/elements"
                                                        user={useUserStore.getState().user}
                                                    />
                                                    <FormQuestionElement
                                                        path="/forms/:form_id/questions/:question_id/save-element/:id?"
                                                        user={useUserStore.getState().user}
                                                    />
                                                    <IsicomTest path="/isicom" user={useUserStore.getState().user} />
                                                    <SupportingDocumentCodes
                                                        path="/supporting-document-codes"
                                                        user={useUserStore.getState().user}
                                                    />
                                                    <SupportingDocumentCode
                                                        path="/supporting-document-codes/:id"
                                                        user={useUserStore.getState().user}
                                                    />
                                                    <SupportingDocumentRE7
                                                        path="/supporting-document-re7/:id"
                                                        user={useUserStore.getState().user}
                                                    />

                                                    <Login path="/login" />
                                                    <ForgotPassword path="/forgot-password" />
                                                    <Profile path="/profile/" user={useUserStore.getState().user} />

                                                    <SaveQuote path="/save-quote/:id?" user={useUserStore.getState().user} />

                                                    <Fields path="/fields" user={useUserStore.getState().user} />
                                                    <FieldSave path="/save-field/:id?/:productCode?"
                                                        user={useUserStore.getState().user} />
                                                    <FieldGroups path="/field-groups" user={useUserStore.getState().user} />
                                                    <SaveFieldGroup path="/save-field-group/:id?" user={useUserStore.getState().user} />

                                                    <ProductFields path="/products/:productKey/fields"
                                                        user={useUserStore.getState().user} />

                                                    <CustomerSave path="/save-customer/:id?" />

                                                    <Formulas path="/products/:productKey/formulas" user={useUserStore.getState().user} />

                                                    <SaveFormula path="/products/:productKey/save-formula/:formulaKey?"
                                                        user={useUserStore.getState().user} />

                                                    <Scripts path="/scripts/:categoryId?" user={useUserStore.getState().user} />
                                                    <SaveScript path="/save-script/:id?" user={useUserStore.getState().user} />

                                                    <DocumentTemplates path="/document-templates" user={useUserStore.getState().user} />
                                                    <EmailTemplates path="/email-templates" user={useUserStore.getState().user} />
                                                    <SaveEmailTemplate path="/email-templates/save/:id?"
                                                        user={useUserStore.getState().user} />

                                                    <SaveDocumentTemplate path="/save-document-template/:id?"
                                                        user={useUserStore.getState().user} />

                                                    <SaveDocument path="/save-document/:id?" user={useUserStore.getState().user} />

                                                    <Covers path="/products/:productKey/covers" user={useUserStore.getState().user} />

                                                    <SaveCover path={`/save-cover/:productKey/:coverKey?`}
                                                        user={useUserStore.getState().user} />

                                                    <SaveFormulaCover
                                                        path="/save-formula-cover/:productKey/:formulaKey/:coverKey?"
                                                        user={useUserStore.getState().user} />

                                                    <FormulaCovers path="/formulas/:productKey/:formulaKey/covers"
                                                        user={useUserStore.getState().user} />

                                                    <SavePolicy path="/save-policy/:id/:contractId?"
                                                        user={useUserStore.getState().user} />

                                                    <WithPermission path="/events"
                                                        requiredPermissions={[PERMISSIONS.CAN_SHOW_EVENTS]}
                                                        renderOtherWise={UnauthorisedAccess()}
                                                    >
                                                        <Events user={useUserStore.getState().user} />
                                                    </WithPermission>

                                                    <SaveEvent path="/save-event/:id?" user={useUserStore.getState().user} />

                                                    <SignContract path="/policies/:policyId/contracts/:contractId/sign"
                                                        user={useUserStore.getState().user} />


                                                    <WithPermission
                                                        path="/invoicings"
                                                        requiredPermissions={[PERMISSIONS.BILLING_NAVBAR_TAB]}
                                                        renderOtherWise={UnauthorisedAccess()}
                                                    >
                                                        <Invoicings user={useUserStore.getState().user} />
                                                    </WithPermission>

                                                    <WithPermission
                                                        path="/invoicings/:id"
                                                        requiredPermissions={[PERMISSIONS.BILLING_NAVBAR_TAB]}
                                                        renderOtherWise={UnauthorisedAccess()}
                                                    >
                                                        <Invoicing user={useUserStore.getState().user} />
                                                    </WithPermission>

                                                    <UnpaidFiles path="/unpaid-files" user={useUserStore.getState().user} />
                                                    <UnpaidFile path="/unpaid-file/:id" user={useUserStore.getState().user} />

                                                    <SignContract path="/policies/:policyId/contracts/:contractId/sign"
                                                        user={useUserStore.getState().user} />

                                                    <SignCallback path="/sign-callback" user={useUserStore.getState().user} />

                                                    <SaveClaim path="/claims/save/:id?" user={useUserStore.getState().user} />

                                                    <ProductSave path="/products/save/:id?" user={useUserStore.getState().user} />
                                                    <SaveNote path="/notes/save/:id?" user={useUserStore.getState().user} />

                                                    <MigrationComponent path="/migration" user={useUserStore.getState().user} />

                                                    <TerminationReasons path="/termination-reasons" user={useUserStore.getState().user} />

                                                    <ScriptCategories path="/script-categories" user={useUserStore.getState().user} />

                                                    <ScheduledTasks path="/scheduled-tasks" user={useUserStore.getState().user} />
                                                    <ScheduledTask path="/scheduled-tasks/:id" user={useUserStore.getState().user} />

                                                    <Disks path="/disks" user={useUserStore.getState().user} />

                                                    <WithPermission
                                                        path="/settings"
                                                        requiredRoles={[ROLES.SUPER_ADMIN]}
                                                        requiredPermissions={[]}
                                                        renderOtherWise={UnauthorisedAccess()}
                                                    >
                                                        <Settings user={useUserStore.getState().user} />
                                                    </WithPermission>
                                                </Router>
                                            </div>
                                        </div>
                                    </main>
                                </div>
                            </NotificationProvider>
                        </ConfirmationModalProvider>
                    </InstantSearch>
                </PrimeReactProvider>
            </>
        );
    }
}
